/**
 * @generated SignedSource<<56b9b3e8b993257cbd8bbb73ff300d83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PlaceholderSidePanel_sourcePerson$data = {
  readonly " $fragmentSpreads": FragmentRefs<"MatchDetailTab_person">;
  readonly " $fragmentType": "PlaceholderSidePanel_sourcePerson";
};
export type PlaceholderSidePanel_sourcePerson$key = {
  readonly " $data"?: PlaceholderSidePanel_sourcePerson$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlaceholderSidePanel_sourcePerson">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PlaceholderSidePanel_sourcePerson",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MatchDetailTab_person"
    }
  ],
  "type": "people",
  "abstractKey": null
};

(node as any).hash = "be0af7e4ddd3c151d77eadf61ce5f9cf";

export default node;
